import { type FC } from 'react';
import type { AgentDefinitionV1 } from '@/model/Agent.model';
import Button from '@/components/UI/Button/Button';
import { getAgentIcon } from '@/components/Agents/AgentUtils';
import { web as webRoute } from '@/support/route';
import styles from './AgentCard.module.scss';

interface AgentCardProps {
  agent: AgentDefinitionV1;
}

/**
 * Displays a single AI agent as a card with icon, name, description, and a run action.
 */
const AgentCard: FC<AgentCardProps> = ({ agent }) => {
  return (
    <div
      className={styles.card}
      data-test-component="AgentCard"
      data-test-element="container"
      data-testid={`agent-card-${agent.slug}`}
    >
      <div className={styles.header} data-test-element="header">
        <span data-test-element="icon">{getAgentIcon(agent.slug)}</span>
        <span className="f4 basier-med lh-title near-black" data-test-element="name">
          {agent.name}
        </span>
      </div>
      <p className={`${styles.description} f6 lh-copy near-black ma0`} data-test-element="description">
        {agent.description}
      </p>
      <div className={styles.footer} data-test-element="footer">
        <Button primary url={webRoute('agents.setup', { slug: agent.slug })} testId={`agent-card-run-${agent.slug}`}>
          Run agent
        </Button>
      </div>
    </div>
  );
};

export default AgentCard;
